import React, { useEffect } from 'react'

import { useAuth } from 'hooks/UseAuth'
import { useWebsocketConnection } from 'providers/WebsocketProvider'

import { DesignPreviewUpdate } from 'screens/Calendar/useDesignPreviewSync'
import { Design } from '../RecommendMoreContentWizard'

interface DesignVersionUpdate {
  op: 'version_update'
  version: number
}

interface Props {
  designs: (Design | undefined)[]
  setDesigns: React.Dispatch<React.SetStateAction<(Design | undefined)[]>>
}

export const useDesignChannelSubscription = ({ designs, setDesigns }: Props) => {
  const auth = useAuth()
  const websocketConnection = useWebsocketConnection()

  useEffect(() => {
    if (!auth || !websocketConnection) return

    const filteredDesigns = designs.filter((d) => !!d) as Design[]
    const subscriptions = filteredDesigns.map((design) => {
      return websocketConnection.subscriptions.create(
        {
          channel: 'DesignPreviewChannel',
          key: design.id,
        },
        {
          received(data: DesignPreviewUpdate | DesignVersionUpdate) {
            if (data.op === 'preview_update') {
              setDesigns((prev) => {
                return prev.map((oldDesign) => {
                  if (oldDesign?.id === design.id) {
                    return {
                      ...design,
                      preview_url: data.image_url,
                      last_rendered_version: data.last_rendered_version,
                    }
                  }
                  return oldDesign
                })
              })
            }
            if (data.op === 'version_update') {
              setDesigns((prev) => {
                return prev.map((oldDesign) => {
                  if (oldDesign?.id === design.id) {
                    return {
                      ...design,
                      version: data.version,
                    }
                  }
                  return oldDesign
                })
              })
            }
          },
        },
      )
    })

    return () => {
      subscriptions.forEach((sub) => sub.unsubscribe())
    }
  }, [auth, websocketConnection, designs, setDesigns])
}
